export const DOCUMENT_TYPES = [
    { value: 'DNI', label: 'DNI', mask: '########', placeholder: '8 dígitos' },
    { value: 'CE', label: 'Carnet de Extranjería', mask: '', placeholder: 'Ej: 001234567' },
    { value: 'PASAPORTE', label: 'Pasaporte', mask: '', placeholder: 'Ej: AB123456' },
    { value: 'RUC', label: 'RUC', mask: '###########', placeholder: '11 dígitos' },
    { value: 'CARNET_EXTRANJERIA', label: 'Carnet Extranjería', mask: '', placeholder: 'Ej: CE1234567' },
];

export const getDocumentTypeLabel = (value) => {
    const found = DOCUMENT_TYPES.find(dt => dt.value === value);
    return found ? found.label : value;
};